import { FunctionComponent } from 'react'
import { useHistory } from 'react-router-dom'
import { Text } from '@conexasaude/conexa-hero'
import Icon from '@/components/RebrandedHeroIcons'
import Modal from '@/components/RebrandedModal'
import { useModalContext } from '@/components/RebrandedModal/contexts/ModalContext'
import { useStyles } from './styles'
import { DeviceErrorModalProps } from './types'
import { openWhatsappSupport } from '@/utils/openWhatsappSupport'

const DeviceErrorModal: FunctionComponent<DeviceErrorModalProps> = props => {
  const {
    consultationId,
    canReschedule,
    professionalType,
    professionalId,
    tokenId,
  } = props

  const { closeModal } = useModalContext()
  const history = useHistory()

  const styles = useStyles()

  const handleConfirm = () => {
    if (consultationId) {
      history.push(`/meus-atendimentos/atendimento/${consultationId}`)

      return
    }

    history.push('/meus-atendimentos')
  }

  const handleSupport = () => {
    openWhatsappSupport()
    closeModal()
  }

  const handleReschedule = () => {
    history.push(
      `/atendimento-agendado/categoria/${professionalType}/${professionalId}/${tokenId}`,
    )
  }

  return (
    <Modal
      id="DEVICE_ERROR"
      onDismiss={closeModal}
      primaryActionLabel="Ir para consultas"
      primaryAction={handleConfirm}
      negativeActionLabel="Conversar com suporte"
      negativeAction={handleSupport}
      secondaryActionLabel={canReschedule ? 'Reagendar' : null}
      secondaryAction={handleReschedule}
      size={canReschedule ? 572 : 472}
    >
      <div css={styles.illustrationWrapper}>
        <Icon name="user-holding-phone-error" width="172px" />
      </div>
      <Text css={styles.caption}>
        O aparelho apresenta problemas que podem prejudicar sua conversa com o
        profissional.
      </Text>
    </Modal>
  )
}

export { DeviceErrorModal }
